// NOTE: Any changes to the prop types here should be reflected in typescript
import PropTypes from 'prop-types';

// ===================
// ===================
// banner props
// ===================
// ===================

export const bannerPropShape = PropTypes.exact({
  id: PropTypes.string.isRequired,
  cta: PropTypes.exact({
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  }),
  headline: PropTypes.string,
  message: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf([
    // only dark variants are used for site-wide banners
    'error-dark',
    'info-dark',
    'promo-dark',
  ]).isRequired,
});

// ===================
// ===================
// slimBanner props
// ===================
// ===================

export const slimBannerPropShape = PropTypes.exact({
  id: PropTypes.string.isRequired,
  cta: PropTypes.oneOfType([
    PropTypes.exact({
      text: PropTypes.string,
      url: PropTypes.string.isRequired,
    }),
    PropTypes.exact({
      text: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    }),
  ]).isRequired,
  icon: PropTypes.node,
  location: PropTypes.oneOf(['top', 'bottom']),
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf([
    // only dark variants are used for site-wide banners
    'info-light',
    'promo-dark',
    'dark',
    'error-dark',
  ]),
});

// ===================
// ===================
// region
// ===================
// ===================

const approvedRegions = ['US', 'UK'] as const;

export const regionEnum = PropTypes.oneOf(approvedRegions).isRequired;
